import type { MessageResponse } from '../../../api';
import {
  author_type,
  message_type,
  messageBoxVariantClasses,
  messageInterruptedVariantClasses,
} from './const';

export const getMessageBoxVariantClasses = (
  authorType: string | undefined,
  messageType?: string | undefined
): string => {
  if (
    messageType === message_type.VOICE_INTERRUPTED &&
    authorType !== author_type.USER
  ) {
    return messageInterruptedVariantClasses;
  }

  return (
    messageBoxVariantClasses[authorType as author_type] ??
    messageBoxVariantClasses[author_type.ASSISTANT]
  );
};

export const filterParallelSTTContent = (text: string): string => {
  if (!text) return text;

  const regex = /\[\$hideTxt.*?endHideTxt\$\]/gs;
  return text.replace(regex, '').trim();
};

export const filterMessages = (
  messages: MessageResponse[],
  showParallelSTT: boolean = true
): MessageResponse[] => {
  const groupById = new Map<string, MessageResponse>();
  for (const msg of messages) {
    groupById.set(msg?.id as string, msg);
  }

  let filtered = Array.from(groupById.values());

  if (!showParallelSTT) {
    filtered = filtered.map(msg => ({
      ...msg,
      message_text: filterParallelSTTContent(msg.message_text || ''),
    }));
  }

  return filtered.sort(
    (a, b) =>
      new Date(a.timestamp!).getTime() - new Date(b.timestamp!).getTime()
  );
};
